import { useEffect } from 'react';
import LandingNav from '../components/landing/LandingNav';
import LandingFooter from '../components/landing/LandingFooter';
import FeedbackHero from '../components/feedback/FeedbackHero';
import FeedbackSection from '../components/feedback/FeedbackSection';
import styles from './FeedbackPage.module.css';

// Public feedback page. Reuses the marketing nav/footer and owns its own scroll container
// (global `body { overflow: hidden }` for the app shell). Submissions email the team via
// the shared Resend flow, same as the contact and data-removal forms.
export default function FeedbackPage() {
  useEffect(() => {
    document.getElementById('top')?.scrollTo({ top: 0 });
  }, []);

  return (
    <div id="top" className={styles.page}>
      <LandingNav />
      <main>
        <FeedbackHero />
        <FeedbackSection />
      </main>
      <LandingFooter />
    </div>
  );
}
